import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { Link } from '@uhg-abyss/web/ui/Link';
import { Text } from '@uhg-abyss/web/ui/Text';
import { event } from '@uhg-abyss/web/tools/event/event';
import { MediaQuery } from '@uhg-abyss/web/ui/MediaQuery';
import { PictureCard, PictureCardSmallerScreen } from './PictureCard';

const HEADER = 'Your Featured News';
const VIEW_ALL_NEWS_URL =
  'https://uhcprovider.com/en/resource-library/news/news-updates.html#sort=date%20descending';

const YourFeaturedNewsContainer = styled('div', {
  'padding-bottom': '48px',
});
const HeaderContainer = styled('div', {});

const HeaderLargeScreen = styled(Text, {
  fontFamily: 'UHCSerif,Georgia Bold,serif',
  fontWeight: '$semibold',
  marginBottom: '8px',

  '&.abyss-text-root': {
    height: 32,
    fontSize: 32,
    lineHeight: '48px',
  },
});

const HeaderSmallerScreen = styled('h4', {
  height: 26,
  fontSize: 26,
  color: '$primary1',
  fontWeight: 'bold',
  marginBottom: '8px',
});

const date = new Date();
const year = date.getFullYear();
const month = date.toLocaleString('default', { month: 'long' });
const abbreviatedMonth = month.toLowerCase().substring(0, 3);
const monthYear = `${month}\u00A0${year}`;

const onClick = () => {
  event('YOUR_FEATURED_NEWS_WIDGET_CLICK', {
    interactionValue: 'View All News',
    interactionContext: '',
  });

  event('EXIT_LINK_NAVIGATE_YOUR_FEATURED_NEWS', {
    linkText: 'View All News',
    linkUrl: VIEW_ALL_NEWS_URL,
  });
};

const pictureCardContent = [
  {
    id: 'medical-policy-updates',
    dataTestidIcon: 'medical-policy-updates-icon',
    dataTestidLabel: 'medical-policy-updates-label',
    icon: <IconBrand icon="document_multiple" size={46} />,
    title: 'Medical policy updates:',
    date: monthYear,
    url: `https://uhcprovider.com/en/resource-library/news/${year}/mpub-updates-${abbreviatedMonth}-${year}.html`,
  },
  {
    id: 'reimbursement-policy-updates',
    dataTestidIcon: 'reimbursement-policy-updates-icon',
    dataTestidLabel: 'reimbursement-policy-updates-label',
    icon: <IconBrand icon="piggy_bank" size={46} />,
    title: 'Reimbursement policy updates:',
    date: monthYear,
    url: `https://uhcprovider.com/en/resource-library/news/${year}/rpub-${abbreviatedMonth}-${year}.html`,
  },
  {
    id: 'pharmacy-and-clinical-policy-updates',
    dataTestidIcon: 'pharmacy-and-clinical-policy-updates-icon',
    dataTestidLabel: 'pharmacy-and-clinical-policy-updates-label',
    icon: <IconBrand icon="pill" size={46} />,
    title: 'Pharmacy and clinical updates:',
    date: monthYear,
    url: `https://uhcprovider.com/en/resource-library/news/${year}/pcub-updates-${abbreviatedMonth}-${year}.html`,
  },
  {
    id: 'speciality-medical-injectable-drug-program-updates',
    dataTestidIcon: 'speciality-medical-injectable-drug-program-updates-icon',
    dataTestidLabel: 'speciality-medical-injectable-drug-program-updates-label',
    icon: <IconBrand icon="syringe" size={46} />,
    title: 'Specialty Medical Injectable Drug program updates:',
    date: monthYear,
    url: `https://uhcprovider.com/en/resource-library/news/${year}/sdub-updates-${abbreviatedMonth}-${year}.html`,
  },
];

export const YourFeaturedNews = () => {
  return (
    <YourFeaturedNewsContainer>
      <HeaderContainer>
        <MediaQuery largerThan={985}>
          <HeaderLargeScreen
            data-testid="your-featured-news-label-large-screen"
            color="$primary1"
          >
            {HEADER}
          </HeaderLargeScreen>
        </MediaQuery>
        <MediaQuery smallerThan={985}>
          <HeaderSmallerScreen data-testid="your-featured-news-label-smaller-screen">
            {HEADER}
          </HeaderSmallerScreen>
        </MediaQuery>
        <p data-testid="your-featured-news-subtext">
          UnitedHealthcare news includes updates for care providers, practice
          managers, facilities and hospitals.
        </p>
      </HeaderContainer>
      <MediaQuery largerThan={985}>
        <PictureCard pictureCardContent={pictureCardContent} />
      </MediaQuery>
      <MediaQuery smallerThan={985}>
        <PictureCardSmallerScreen pictureCardContent={pictureCardContent} />
      </MediaQuery>
      <Link
        data-testid="view-all-news-link"
        fontWeight="bold"
        href={VIEW_ALL_NEWS_URL}
        onClick={onClick}
      >
        View All News
      </Link>
    </YourFeaturedNewsContainer>
  );
};
